import { MENU_ITEM_STYLE } from '@ui/menus/Menu';
import { makeStyles } from 'tss-react/mui';

export const usePhasesCardStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '100%',
  },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%',
  },
  overviewRoot: { alignItems: 'flex-start' },
  triggerCarbonIcon: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    position: 'relative',
    top: '-1px',
    color: 'inherit',
  },
  groupsPanel: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    width: 'max-content',
    maxWidth: 'calc(100vw - 32px)',
    height: 'max-content',
    overflow: 'hidden',
    borderRadius: 6,
    outline: '1px solid rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    '& button': {
      fontFamily: theme.typography.fontFamily,
    },
  },
  groupsPanelLeft: {
    left: 12,
    transform: 'none',
  },
  presetHeading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    minHeight: MENU_ITEM_STYLE.MIN_HEIGHT,
    padding: `${MENU_ITEM_STYLE.PADDING_Y * 8}px 2px ${MENU_ITEM_STYLE.PADDING_Y * 8}px ${MENU_ITEM_STYLE.PADDING_X * 8}px`,
  },
  presetColumnSizer: {
    width: 'max-content',
    height: 0,
    padding: '0 28px 0 34px',
    visibility: 'hidden',
    pointerEvents: 'none',
  },
  presetSizerLabel: {
    maxWidth: 300,
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  presetColumn: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: 'max-content',
    padding: '8px',
    '&::after': {
      position: 'absolute',
      top: 24,
      right: 0,
      bottom: 24,
      width: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      content: '""',
    },
  },
  savedScopesError: { padding: '0 8px', fontSize: 12 },
  presetList: {
    maxHeight: '50vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  presetRow: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.03)' },
  },
  presetOption: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    height: 32,
    margin: 0,
    padding: '0 16px 0 0',
    border: 0,
    borderRadius: 6,
    appearance: 'none',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.72)',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    '&:focus-visible': {
      boxShadow: `0 0 0 1px ${theme.palette.custom.focus}`,
      outline: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: 13,
      fontWeight: 400,
      lineHeight: 1.3,
    },
  },
  presetOptionSelected: {
    color: 'rgba(0, 0, 0, 0.88)',
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  presetLabel: {
    maxWidth: 300,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'grid',
    alignItems: 'center',
    minWidth: 0,
    '&::after': {
      gridArea: '1 / 1',
      fontWeight: 600,
      visibility: 'hidden',
      whiteSpace: 'nowrap',
      content: 'attr(data-label)',
    },
  },
  presetLabelText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    gridArea: '1 / 1',
    whiteSpace: 'nowrap',
  },
  presetCheck: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 34,
    height: 32,
    padding: '0 8px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    opacity: 0,
    '& svg': {
      display: 'block',
      width: 18,
      height: 18,
      fontSize: 18,
    },
  },
  presetCheckOn: {
    opacity: 1,
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    padding: 0,
    border: 'none',
    borderRadius: 5,
    appearance: 'none',
    backgroundColor: 'transparent',
    color: 'rgba(0,0,0,0.4)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.05)',
      color: 'rgba(0,0,0,0.85)',
    },
  },
  scopeControls: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 28,
    width: 'max-content',
    maxWidth: '100%',
    minWidth: 0,
    padding: '36px 24px 32px',
  },
  widthSizer: {
    position: 'absolute',
    width: 'max-content',
    height: 0,
    overflow: 'hidden',
    visibility: 'hidden',
    pointerEvents: 'none',
  },
  controlSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 10,
    minWidth: 0,
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.2,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  sectionLabelSup: {
    fontSize: '0.75em',
    lineHeight: 0,
    verticalAlign: 'super',
  },
  sectionLabelSub: {
    fontSize: '0.75em',
    lineHeight: 0,
    verticalAlign: 'sub',
  },
  targetField: {
    position: 'relative',
    // Unfocused it is one of the panel's chips: no border, the same tint and
    // radius as the SBEF and carbon options. The outline only appears on edit.
    '& .MuiOutlinedInput-root': {
      paddingLeft: 4,
      paddingRight: 8,
      borderRadius: 6,
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
      '&.Mui-focused': {
        backgroundColor: '#fff',
      },
    },
    '& input': {
      padding: '6px 4px 6px 6px',
      fontSize: 13,
      color: 'rgba(0, 0, 0, 0.8)',
      // Spelled out rather than left to MUI, which renders its placeholder as
      // the input colour at 42% opacity.
      '&::placeholder': {
        color: 'rgba(0, 0, 0, 0.5)',
        opacity: 1,
      },
    },
  },
  targetFieldButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    padding: 0,
    border: 'none',
    borderRadius: 5,
    appearance: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      color: 'rgba(0, 0, 0, 0.85)',
    },
  },
  targetLevelCaret: {
    color: 'rgba(0, 0, 0, 0.5)',
  },
  targetClearButton: {
    color: 'rgba(0, 0, 0, 0.3)',
  },
  targetFieldPreview: {
    // The input keeps DOM focus while another scope is previewed; drop the
    // focused look — outline, background and caret — so the field reads as the
    // preview it is showing.
    '& .MuiOutlinedInput-root.Mui-focused': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
    },
    '& input': {
      caretColor: 'transparent',
    },
  },
  targetPreviewOverlay: {
    // Holds the same input again, at rest, over the one being edited. Opaque
    // white so the edit underneath — text, caret, selection — cannot show
    // through; the input inside paints the chip tint as usual.
    position: 'absolute',
    inset: 0,
    borderRadius: 6,
    backgroundColor: '#fff',
    pointerEvents: 'none',
  },
  targetLevelName: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1,
    color: 'rgba(0, 0, 0, 0.8)',
    whiteSpace: 'nowrap',
  },
  targetLevelAdornment: {
    // Pushed to the field's right edge, where the number never reaches.
    marginLeft: 'auto',
  },
  targetAdornment: {
    marginLeft: 0,
    marginRight: 0,
    gap: 4,
    color: 'rgba(0, 0, 0, 0.4)',
    '& svg': {
      display: 'block',
    },
  },
  sbefOptions: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
  },
  sbefOption: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 30,
    height: 30,
    padding: '0 8px',
    border: 0,
    borderRadius: 5,
    appearance: 'none',
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.38)',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': {
      color: 'rgba(0, 0, 0, 0.8)',
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    '&:focus-visible': {
      boxShadow: `0 0 0 1px ${theme.palette.custom.focus}`,
      outline: 'none',
    },
  },
  sbefOptionSelected: {
    color: 'rgba(0, 0, 0, 0.8)',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  sbefOptionConnectedLeft: {
    marginLeft: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    '&::before': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: -3,
      width: 3,
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      content: '""',
    },
    '&:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  sbefOptionConnectedRight: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  lifecycleControls: {
    maxWidth: '100%',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  carbonOptions: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  carbonOption: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    height: 30,
    margin: 0,
    padding: '0 16px 0 8px',
    border: 0,
    borderRadius: 6,
    appearance: 'none',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.48)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    '&:focus-visible': {
      boxShadow: `0 0 0 1px ${theme.palette.custom.focus}`,
      outline: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: 1,
    },
  },
  carbonOptionSelected: {
    color: 'rgba(0, 0, 0, 0.72)',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  lifetimeNumber: {
    cursor: 'pointer',
    borderRadius: 3,
    padding: '0 2px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
  },
  lifetimeNumberInactive: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  lifetimeEditing: {
    minWidth: '1ch',
    padding: '0 2px',
    borderRadius: 3,
    outline: 'none',
    backgroundColor: '#fff',
    boxShadow: `0 0 0 1px ${theme.palette.custom.focus}`,
    cursor: 'text',
    userSelect: 'text',
    '&:hover': {
      boxShadow: `0 0 0 1px ${theme.palette.custom.focus}`,
    },
  },
  phase: {
    flexShrink: 0,
    marginTop: 0,
    marginBottom: 0,
    fontSize: 12,
    letterSpacing: '0.7px',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    borderRadius: 4,
    padding: '1px 4px',
    fontWeight: 500,
  },
  phaseClickable: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
  phaseInactive: {
    opacity: 0.3,
    '&:hover': {
      opacity: 0.8,
    },
  },
  phaseDisabled: {
    opacity: 0.3,
    cursor: 'default',
  },
}));
